export const IMPORT = 'import';
export const CREATE_PRODUCT = 'create-product';
export const CONFIG_RUN = 'config-run';

export const RUN_ORCHESTRATION_BUTTONS_DATA = [
  {
    id: IMPORT,
    text: 'Import orchestration template',
  },
  {
    id: CREATE_PRODUCT,
    text: 'Create a product variant of your orchestration',
  },
  {
    id: CONFIG_RUN,
    text: 'Configure and submit your orchestration',
  },
];
